import { render, staticRenderFns } from "./modalDeflacionar.vue?vue&type=template&id=6c8a91aa&scoped=true&"
import script from "./modalDeflacionar.vue?vue&type=script&lang=js&"
export * from "./modalDeflacionar.vue?vue&type=script&lang=js&"
import style0 from "./modalDeflacionar.vue?vue&type=style&index=0&id=6c8a91aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8a91aa",
  null
  
)

export default component.exports